/**
 * Backend and IndexedDB expect a boolean. Legacy drafts/records may hold "", null, or "true".
 * Only explicit true opts into model training; everything else is false.
 */
export function normalizeModelTrainingConsent(value) {
  return value === true || value === 'true';
}
